import { Inject, inject, Injectable } from '@angular/core';
import { AUTH_SVC, AuthService } from '@company-box/services';
import { DESIGN_3D_AUTH_GATE, DESIGN_3D_IDLE_LOGOUT, DESIGN_3D_REVIEW_HANDOFF } from '@company-box/design-3d';
import { environment } from '../../environments/environment';
import { ClientSessionStateService } from '../services/sessionState.service';

@Injectable()
class FedexDesign3dReviewHandoff {
  private stateSvc = inject(ClientSessionStateService);

  setReviewPageDetails(details: unknown): void {
    this.stateSvc.updateState({ productDetails: details });
  }
}

// fedex-ui's shell (FXAuthService) already guarantees an authenticated user before this route
// loads - unlike cb-ui, there is nothing to gate here.
@Injectable()
class FedexDesign3dAuthGate {
  ensureAuthenticated(): Promise<void> {
    return Promise.resolve();
  }
}

@Injectable()
class FedexDesign3dIdleLogout {
  private stateSvc = inject(ClientSessionStateService);

  constructor(@Inject(AUTH_SVC) private authService: AuthService) {}

  // Redirects to wherever the user actually came from (ClientSessionStateModel's own referer,
  // set by sessionInterceptor.ts from the upstream cart/login URL - the same value every other
  // "leave the app" exit point already uses: box-style/box-options/review-box's own "back" form,
  // design.component.ts's goBack()) rather than always sending everyone to the generic marketing
  // site. Falls back to the marketing site only if a session never had a referer to begin with.
  // Always redirects, win or lose on the logout call itself - this is a best-effort cleanup, not
  // something that should block the redirect or surface its own error state on failure.
  handleIdleExpired(): void {
    const redirectTo = this.stateSvc.getStateValue('referer') || environment.config.marketingSite;
    this.authService.logout().finally(() => {
      window.location.href = redirectTo;
    });
  }
}

export const DESIGN_3D_FEDEX_PROVIDERS = [
  { provide: DESIGN_3D_REVIEW_HANDOFF, useClass: FedexDesign3dReviewHandoff },
  { provide: DESIGN_3D_AUTH_GATE, useClass: FedexDesign3dAuthGate },
  { provide: DESIGN_3D_IDLE_LOGOUT, useClass: FedexDesign3dIdleLogout },
];
